import { createReducer, on } from "@ngrx/store";
import { User } from "../../models/user";
import { addSuccessUserAct, resetUserAct, setViolationsUserAct, updateSuccessUserAct, loadUserByIdAct, loadAllRolesAct, findUserAct } from "./users.actions";
import { Role } from "../../models/rol";

const user: User = new User();
const roles: Role[] = [];
export const usersReducer = createReducer(
    {
        user,
        violations: {},
        loading: true,
        roles
    },
    on(resetUserAct, (state) => ({
        user: { ...user },
        violations: {},
        loading: state.loading,
        roles: state.roles
    })),
    /*on(findAllUser, (state, { users }) => ({
        users: [...users],
        paginator: state.paginator,
        user: state.user,
        violations: state.violations
    }
    )),*/
    /*on(findAllPageableUserAct, (state, { users, paginator }) => ({
        users: [...users],
        paginator: {... paginator},
        user: state.user,
        violations: state.violations,
        loading: false,
        roles: state.roles
    }
    )),*/
    /*on(findUserAct, (state, { id }) => ({
        users: state.users,
        paginator: state.paginator,
        user: state.users.find(user => user.id == id) || new User(),
        violations: state.violations,
        loading: false
    })),*/
    on(findUserAct, (state, { id }) => ({
        user: state.user,
        violations: state.violations,
        loading: true,
        roles: state.roles
    })),
    on(loadUserByIdAct, (state, { user }) => ({
        user: { ...user }, //state.users.find(user => user.id == id) || new User(),
        violations: state.violations,
        loading: false,
        roles: state.roles
    })),
    /*on(setPaginatorUser, (state, { paginator }) => ({
        users: state.users,
        paginator: { ...paginator },
        user: state.user,
        violations: state.violations
    })),*/
    on(addSuccessUserAct, (state, { userNew }) => ({
        user: { ...userNew },
        violations: {},
        loading: state.loading,
        roles: state.roles
    })),
    on(updateSuccessUserAct, (state, { userUpdated }) => ({
        user: {... userUpdated},
        violations: {},
        loading: state.loading,
        roles: state.roles
    })),
    on(setViolationsUserAct, (state, { userForm, violations }) => ({
        user: { ...userForm },
        violations: {...violations},
        loading: state.loading,
        roles: state.roles
    })),
    on(loadAllRolesAct, (state, { roles }) => ({
        user: { ...user },
        violations: state.violations,
        loading: false,
        roles: roles
    }))
);